<div class="card-body" *ngIf="usersDataSearch">
  <div class="search-header d-flex">
    <!-- search -->
    <div class="d-flex search-container bg-light" style="width: 380px;">
      <div class="search-text d-flex">
        <input type="text" class="search" (input)="applyFilter()" [(ngModel)]="searchParam"
          [attr.placeholder]="'customer.searchUser' | translate">
        <div class="d-flex flex-row align-items-center">
          <span class="exit" (click)="clearSearch()"></span>
          <span class="line"></span>
        </div>
      </div>
      <span class="search-icon" (click)="applyFilter()"><i class="fa fa-search"></i></span>
    </div>
    <!-- ./search -->
    <div class="add-button-container">
      <button class="custom-button add-button" (click)="openAddUserModal()" translate>customer.addUser<i
          class="fa fa-plus"></i></button>
    </div>
  </div>
  <div style="text-align: center; padding: 24px;" *ngIf="usersDataSearch && !usersDataSearch.length">
    <p translate>user.noUsersFound</p>
  </div>

  <ng-container *ngIf="usersDataSearch && usersDataSearch.length">
    <div class="form-group" style="max-width: 150px;">
      <label for="sort">Sort by:</label>
      <select name="sort" id="sort" class="form-control" (change)="handleSortUsers($event)">
        <option value="lastOnline" selected>Last Online</option>
        <option value="name">Name</option>
      </select>
    </div>

    <h5 style="font-weight: bold;">Filters</h5>
    <div class="form-group">
      <label>Last Online status:</label>
      <div class="d-flex" style="gap: 10px">
        <div *ngFor="let option of filterOptions">
          <input 
            type="checkbox" 
            [checked]="selectedFilter === option.value" 
            (change)="selectFilter(selectedFilter === option.value ? null : option.value)">
  
            {{ option.label }}
        </div>
      </div>
    </div>

    <div class="row">
      <app-user-item class="col-xl-3-custom col-lg-4 col-md-6 col-sm-12" *ngFor="let user of usersDataSearch | slice: (page-1) * perPage : (page-1) * perPage + perPage" 
            [user]="user" 
            (goToUser)="navigateToUser($event)"
            (deleteUser)="deleteUser($event)"
            (reloadUser)="reloadUserData($event)"
            class="col-xl-3-custom col-lg-4 col-md-6 col-sm-12">
      </app-user-item>
    </div>
  </ng-container>
  <div class="clearfix" style="width: 100%"></div>
  <ngb-pagination [collectionSize]="usersDataSearch.length" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
    [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
</div>
<!-- /.card-body -->

<app-add-user #dialogAddUser  [applications]="" (formBody)="sendUser($event)" ></app-add-user>
